export default "__VITE_PUBLIC_ASSET__9b5be68a__"